var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLbIconShield = props => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 7.24111C14 10.6753 11.4403 13.8868 8 14.6667C4.55972 13.8868 2 10.6753 2 7.24111V4.54285C2 3.92828 2.36888 3.37503 2.93213 3.14306L6.6818 1.59529C7.52666 1.24601 8.47333 1.24601 9.31688 1.59529L13.0665 3.14306C13.6311 3.37636 13.9987 3.92828 13.9987 4.54285V7.24111H14Z",
  stroke: "#414151",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), /*#__PURE__*/React.createElement("g", {
  id: "Path_2"
}))));
export default SvgLbIconShield;